import script from "./DonateProvider.vue?vue&type=script&setup=true&lang=ts"
export * from "./DonateProvider.vue?vue&type=script&setup=true&lang=ts"

import "./DonateProvider.vue?vue&type=style&index=0&id=50d1f8bc&scoped=true&lang=scss"
import "./DonateProvider.vue?vue&type=style&index=1&id=50d1f8bc&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50d1f8bc"]])

export default __exports__